/* eslint-disable default-param-last */
/**
 * @description Reducer sobre as funções da edição de exame de eficiëncia
 * @author Diego Sabino Amorim de Araújo
 * @file edicaoExame/exameEficienciaReducer.js
 *
 * @license Copyright (c) 2021 SIGEP DIGETI ITEP/RN
 */

import types from 'utils/actionTypes'

const initialState = {
  exameEficiencia: {
    numeroExame: {},
    historico: {
      objetoDePericia: '',
    },
    descricao: {
      vestigiosExaminados: [],
    },
    examesEficiencia: [],
  },
  activeStep: 0,
  processandoExameEficiencia: false,
  processandoLaudoViwer: false,
}

const exameEficienciaReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_EXAME_EFICIENCIA: {
      return {
        ...state,
        exameEficiencia: action.exameEficiencia,
      }
    }

    case types.SET_ACTIVE_STEP_EFICIENCIA: {
      return {
        ...state,
        activeStep: action.activeStep,
      }
    }

    case types.SET_PROCESSANDO_EXAME_EFICIENCIA: {
      return {
        ...state,
        processandoExameEficiencia: action.isProcessando,
      }
    }

    default: {
      return {
        ...state,
      }
    }
  }
}

export default exameEficienciaReducer
